
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16.929"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('rect',{staticClass:"a",attrs:{"width":"14","height":"8","rx":"2","transform":"translate(0 6.929)"}}),_c('path',{staticClass:"a",attrs:{"d":"M2.997 6.743v-3a3.746 3.746 0 117.492 0v3"}})])])
          )
        }
      }
    